import React from 'react'

import PropTypes from 'prop-types'

import { getRentalProfileItems } from 'app/sm/helpers'
import ProfileItemsContainer from 'app/sm/rental_reputation/components/profile_items_container'

class RentalReputation extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    this.props.fetchCompleteness()
  }

  render() {
    const { completeness, error } = this.props
    const rentalProfileItems = getRentalProfileItems()

    return (
      <div className="rental-reputation-container">
        <div className="">
          <div className="content row">
            <div className="col-xs-12 mt25">
              <ul className="references">
                <ProfileItemsContainer
                  title="Application Items"
                  message="Items for including on Rental applications."
                  completeness={completeness}
                  profileItems={rentalProfileItems}
                />
              </ul>
            </div>
          </div>

          {error && (
            <div className="row">
              <div className="col-sm-12">
                <div className="alert alert-danger">
                  <div>{error}</div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}

RentalReputation.propTypes = {
  fetchCompleteness: PropTypes.func.isRequired,
  completeness: PropTypes.object.isRequired,
  error: PropTypes.string,
}

RentalReputation.defaultProps = {
  error: '',
}

export default RentalReputation
